const OPTIONS_TYPE_CONVENTION: Record<
  'key' | 'text' | 'value',
  number | string | string
>[] = [
  {
    key: 1,
    text: 'Utilisation de la convention-type de PACS (formulaire CERFA n°15726 completé).',
    value: 'convention-type-pacs',
  },
  {
    key: 2,
    text: "Utilisation d'une convention spécifique rédigée par les partenaires.",
    value: 'divorce',
  },
];

export default OPTIONS_TYPE_CONVENTION;
